<template>
  <div class="maintain-scheme-green">
    <p>
      <i v-if="state==='success'" class="iconfont icon-xiaoshou-tuihuo-denghou"></i>
      <i v-if="state==='error'" class="iconfont icon-xiaoshou-tuihuo-jujue"></i>
    </p>
    <p class="title-text">{{'请等待上级审批！'}}</p>
  </div>
</template>

<script>
export default {
  name: 'returnData',
  props: {
    titleText: {
      type: String
    },
    state: {
      type: String,
      default: 'success'
    }

  }

}
</script>

<style lang="scss" scoped>
.maintain-scheme-green {
  height: 130px;
  background: rgba(243, 247, 255, 1);
  border-radius: 4px;
  text-align: center;
  padding-top: 20px;
  i {
    width: 50px;
    color: #60c96d;
    font-size: 38px;
  }
  .title-text {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }
}
</style>
